import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
    DatiqGraphComponent,
    DatiqGraphLegendComponent
} from './components';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({ declarations: [DatiqGraphComponent, DatiqGraphLegendComponent],
    exports: [DatiqGraphComponent, DatiqGraphLegendComponent], imports: [CommonModule,
        MatIconModule,
        MatTooltipModule,
        DatiqIconsModule,
        MatSlideToggleModule,
        MatCheckboxModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class DatiqGraphModule {}
